import { gql } from "@apollo/client";

export const updateKeywordGroup = gql`
  mutation UpdateKeywordGroup(
    $id: ID!
    $name: String!
    $slug: String!
    $type: KeywordGroupType!
    $imageUrl: String
    $keywords: [String!]!
  ) {
    updateKeywordGroup(
      id: $id
      name: $name
      slug: $slug
      type: $type
      imageUrl: $imageUrl
      keywords: $keywords
    ) {
      id
      name
      slug
      imageUrl
      type
      keywords
      keywordsGroupIds
      metadata
    }
  }
`;
